import { version } from '../package.json';

export const app_name = 'Simple Calendar';
export const app_version = version;
export const app_stability = 'beta';
export const app_author = 'https://kamal.morjal.com';
